import { Component, input, computed } from "@angular/core";
import { TableRow } from "../info-table/info-table.component";
import { EvExpandedIconComponent } from "ev-expanded-icon";
import { NgClass } from "@angular/common";
import { PropertyInformationDto } from "src/models/estate/property-information.model";
import { PublicBuildingInfo, UnitInfo } from "src/models/estate/public-building-info.model";
import { BuildingsAccordionsComponent } from "./buildings-accordions/buildings-accordions.component";

@Component({
    selector: "buildings",
    templateUrl: "./buildings.component.html",
    styleUrls: ["../styles/component-accordion.scss", "./buildings.component.scss"],
    imports: [NgClass, EvExpandedIconComponent, BuildingsAccordionsComponent],
})
export class BuildingsComponent {
    propertyInformation = input.required<PropertyInformationDto>();
    historyExpanded: boolean = false;

    numberOfHistoricBuildings = computed(() => this.propertyInformation().historicBuildings.filter((b) => !b.buildingInfo.reconstructionOrder).length);
}

export class Table {
    constructor(public header: string, public arealchages: number, public leftcolumn: TableRow[], public rightcolumn: TableRow[]) {}

    expanded: boolean = false;
    usageUnits: UnitInfo[] = [];
    buildingInfo: PublicBuildingInfo;
    changes: PublicBuildingInfo[] = [];
}
